module.exports = __webpack_public_path__ + "img/arrow-back.83cd8140.svg";